import { render, staticRenderFns } from "./ModalBottom.vue?vue&type=template&id=54c6edfe&scoped=true"
import script from "./ModalBottom.vue?vue&type=script&lang=js"
export * from "./ModalBottom.vue?vue&type=script&lang=js"
import style0 from "./ModalBottom.vue?vue&type=style&index=0&id=54c6edfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../corporativo/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c6edfe",
  null
  
)

export default component.exports